import React from 'react';
import { Redirect } from 'react-router-dom';

import { WWW_ROUTES } from '@root/root/routes';

export const CheckoutMovingCart = () => {
  return (
    <Redirect
      to={{
        pathname: WWW_ROUTES.PRODUCT_PAGE_STORAGE,
        state: { from: 'moving' },
      }}
    />
  );
};
